import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import PinchableWrap from '../PinchableWrap'
import CloseIcon from '../icons/CloseIcon'
import { CloseButton, ContentWrap, PinchZoomBackdrop } from './MobilePinchZoomDialog.styled'

function MobilePinchZoomDialog({ open, onClose, children }) {
  const container =
    typeof document !== 'undefined' ? document.getElementById('modal-root') || document.body : null

  useEffect(() => {
    if (!open) return
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = prevOverflow
    }
  }, [open, onClose])

  if (!open || !container) return null

  return createPortal(
    <PinchZoomBackdrop role="dialog" aria-modal="true" onClick={onClose}>
      <ContentWrap onClick={(e) => e.stopPropagation()}>
        <PinchableWrap>{children}</PinchableWrap>
      </ContentWrap>
      <CloseButton onClick={onClose} aria-label="Close">
        <CloseIcon />
      </CloseButton>
    </PinchZoomBackdrop>,
    container
  )
}

export default MobilePinchZoomDialog
